import { useMutation } from 'react-query'
import request from '../request'
import { useDealership } from '../../store/zustand/dealershipStore'

export const useAddBrevoCredentials = () => {
  const dealership = useDealership()
  return useMutation((data: any) =>
    request({
      url: `/agencies/${dealership?.organization_id}/dsp/auth/brevo`,
      method: 'POST',
      data,
    }),
  )
}
